import React, { Component } from 'react'
import { observer } from 'mobx-react'
import Controls from './Controls'
import { formatTime } from 'common/utils'
import styles from './index.css'

const Timer = observer(function ({ practiceStore }) {
  return (
    <div className={ styles.timer }>{ formatTime(practiceStore.costTime) }</div>
  )
})

@observer(['practiceStore'])
export default class Header extends Component {
  render () {
    const { practiceStore } = this.props

    return (
      <div className={ styles.root }>
        <div className={ styles.wrap }>
          <div className={ styles.title }>{ practiceStore.practiceName || practiceStore.name }</div>
          <div className={ styles.right }>
            { practiceStore.show.timer ? <Timer practiceStore={ practiceStore } /> : null }
            <Controls />
          </div>
        </div>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Practice/Header/index.js
 **/